import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import "./signUpIcon.css";

const SignUpIcon = (props) => {
  const { style } = props;
  return <FontAwesomeIcon style={style} icon={faUserPlus} />;
};

export default SignUpIcon;
